import React from 'react';
import { Link } from 'react-router-dom';
import 'iconify-icon';

export const FranchiseTestimonials = ({ testimonials }) => {
  if (!testimonials?.length) return null;
  return (
    <section
      className="relative py-20 border-b border-neutral-900"
      style={{ background: 'rgba(10, 10, 10, 0.78)' }}
      data-testid="franchise-testimonials-section"
    >
      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-accent-orange mb-3 block">
            Depoimentos
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#EAEAEA]">
            Depoimentos de eneagramados
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <blockquote
              key={`${t.name || 'tst'}-${i}`}
              data-testid={`franchise-testimonial-${i}`}
              className="relative bg-[#0F0F0F] border border-[#333333] rounded-2xl p-7"
            >
              <iconify-icon
                icon="solar:quote-up-square-linear"
                className="text-3xl text-accent-orange mb-3 block"
              ></iconify-icon>
              <p className="text-[#EAEAEA] italic mb-5 leading-relaxed">&ldquo;{t.text}&rdquo;</p>
              <footer className="text-sm">
                <strong className="text-[#EAEAEA]">{t.name}</strong>
                {t.role && <span className="text-neutral-500"> · {t.role}</span>}
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};

export const FranchiseCases = ({ cases }) => {
  if (!cases?.length) return null;
  return (
    <section
      className="relative py-20 border-b border-neutral-900"
      style={{ background: 'rgba(17, 17, 17, 0.82)' }}
      data-testid="franchise-cases-section"
    >
      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-accent-orange mb-3 block">
            Cases corporativos
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#EAEAEA]">
            Empresas que confiaram nesta unidade
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cases.map((c, i) => (
            <article
              key={`${c.company || 'case'}-${i}`}
              data-testid={`franchise-case-${i}`}
              className="bg-[#0F0F0F] border border-[#333333] rounded-2xl p-6 hover:border-accent-orange transition-colors"
            >
              {c.image && <img src={c.image} alt={c.company} className="h-10 mb-4 object-contain" />}
              <h3 className="font-bold text-[#EAEAEA] mb-2">{c.company}</h3>
              <p className="text-sm text-neutral-400 leading-relaxed">{c.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export const FranchiseFinalCTA = ({ franchise, wppLink }) => {
  const { name, city, partners = [] } = franchise;
  return (
    <section className="relative py-20" style={{ background: 'rgba(10, 10, 10, 0.78)' }}>
      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        {partners.length > 0 && (
          <p className="text-xs font-mono uppercase tracking-widest text-neutral-500 mb-4">
            Sócios: {partners.join(' · ')}
          </p>
        )}
        <h2 className="text-3xl md:text-4xl font-bold text-[#EAEAEA] mb-4">
          Quer agendar seu diagnóstico nesta unidade?
        </h2>
        <p className="text-base md:text-lg text-neutral-400 mb-8">
          Fale direto com a equipe do {name || `IE ${city}`} pelo WhatsApp.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={wppLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="franchise-final-cta-whatsapp"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-accent-orange text-white rounded-full text-sm font-bold uppercase tracking-wider hover:bg-[#E55D00] transition-colors"
          >
            <iconify-icon icon="mdi:whatsapp" className="text-lg"></iconify-icon>
            Falar com a unidade
          </a>
          <Link
            to="/agenda"
            data-testid="franchise-final-cta-agenda"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 border border-[#333333] text-[#EAEAEA] rounded-full text-sm font-bold uppercase tracking-wider hover:border-accent-orange hover:text-accent-orange transition-colors"
          >
            <iconify-icon icon="solar:calendar-linear" className="text-lg"></iconify-icon>
            Ver agenda completa
          </Link>
        </div>
      </div>
    </section>
  );
};
